// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Header Styles */
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: rgba(29, 26, 22, 0.95);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(177, 133, 90, 0.2);
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

[data-theme="light"] .header {
  background: rgba(247, 243, 238, 0.95);
  border-bottom: 1px solid rgba(140, 90, 51, 0.2);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}

/* Left Section - Social Icons */
.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(177, 133, 90, 0.1);
  border: 1px solid rgba(177, 133, 90, 0.3);
  text-decoration: none;
  transition: all 0.3s ease;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.social-icon:hover {
  background: var(--accent-coffee);
  border-color: var(--accent-coffee);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(177, 133, 90, 0.4);
}

.social-icon svg {
  width: 20px;
  height: 20px;
  transition: all 0.3s ease;
}

.social-icon:hover svg {
  transform: scale(1.1);
}

/* LinkedIn - Original blue color */
.social-icon[aria-label="LinkedIn"] svg {
  color: #0077b5;
}

/* Gmail - Original red color */
.social-icon[aria-label="Gmail"] svg {
  color: #ea4335;
}

/* GitHub - Original black color */
.social-icon[aria-label="GitHub"] svg {
  color: #333333;
}

/* Center Section - Profile */
.header-center {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
}


.profile-container {
  display: flex;
  align-items: center;
  gap: 16px;
}

.profile-image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid var(--accent-coffee);
  box-shadow: 0 4px 15px rgba(177, 133, 90, 0.3);
  transition: all 0.3s ease;
}

.profile-image:hover {
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.4);
}

.profile-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.profile-name {
  font-family: 'Playfair Display', 'Times New Roman', serif;
  font-size: 36px;
  font-weight: 400;
  font-style: italic;
  color: var(--text-primary);
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.profile-container:hover .profile-name {
  color: var(--accent-coffee);
  transform: translateX(2px);
}

/* Right Section - Navigation & Theme Toggle */
.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

/* Navigation */
.header-nav {
  display: flex;
  align-items: center;
  gap: 32px;
}

.nav-link {
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  padding: 8px 0;
  position: relative;
  transition: all 0.3s ease;
  letter-spacing: 0.3px;
}

.nav-link::after {
  content: '';
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, var(--accent-coffee), var(--accent-beige));
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: var(--accent-coffee);
  transform: translateY(-1px);
}

.nav-link:hover::after {
  width: 100%;
}

.nav-link.active {
  color: var(--accent-coffee);
  font-weight: 600;
}

.nav-link.active::after {
  width: 100%;
}

/* Navigation Icons */
.nav-icon {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  transition: all 0.3s ease;
}

.nav-link:hover .nav-icon {
  transform: scale(1.1);
}

/* Theme Toggle */
.theme-toggle {
  background: var(--accent-coffee);
  color: var(--accent-cream);
  border: 2px solid var(--border-color);
  border-radius: 50%;
  width: 44px;
  height: 44px;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(177, 133, 90, 0.3);
}

.theme-toggle:hover {
  background: var(--accent-beige);
  transform: scale(1.05) rotate(15deg);
  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.4);
}

/* Mobile Menu Toggle */
.mobile-menu-toggle {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover {
  background: rgba(177, 133, 90, 0.1);
}

.hamburger {
  display: flex;
  flex-direction: column;
  width: 28px;
  height: 20px;
  position: relative;
}

.hamburger span {
  display: block;
  height: 2px;
  width: 100%;
  background: var(--accent-coffee);
  border-radius: 2px;
  transition: all 0.3s ease;
  transform-origin: center;
}

.hamburger span:nth-child(1) {
  margin-bottom: 6px;
}

.hamburger span:nth-child(2) {
  margin-bottom: 6px;
}

.hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(7px, 7px);
}

.hamburger.active span:nth-child(2) {
  opacity: 0;
}

.hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -7px);
}

/* Mobile Navigation */
.mobile-nav {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(29, 26, 22, 0.98);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  border-top: 1px solid rgba(177, 133, 90, 0.3);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
  flex-direction: column;
  padding: 30px 40px;
  gap: 20px;
  z-index: 999;
}

[data-theme="light"] .mobile-nav {
  background: rgba(247, 243, 238, 0.98);
}

.mobile-nav.active {
  display: flex;
}

.mobile-nav .nav-link {
  padding: 16px 20px;
  border-radius: 12px;
  background: rgba(177, 133, 90, 0.1);
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  border: 1px solid rgba(177, 133, 90, 0.2);
  transition: all 0.3s ease;
}

.mobile-nav .nav-link:hover {
  background: var(--accent-coffee);
  color: var(--accent-cream);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);
}

.mobile-nav .nav-link::after {
  display: none;
}

.mobile-nav .nav-link.active {
  background: var(--accent-coffee);
  color: var(--accent-cream);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);
}

/* Mobile Theme Toggle */
.mobile-theme-toggle {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid rgba(177, 133, 90, 0.3);
  display: flex;
  justify-content: center;
}

.mobile-theme-btn {
  width: 50px;
  height: 50px;
  font-size: 20px;
  border-radius: 12px;
  background: rgba(177, 133, 90, 0.1);
  border: 2px solid rgba(177, 133, 90, 0.3);
  transition: all 0.3s ease;
}

.mobile-theme-btn:hover {
  background: var(--accent-coffee);
  transform: scale(1.05);
  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);
}

/* Mobile Overlay */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  z-index: 998;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-container {
    padding: 0 30px;
  }
  
  .header-nav {
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .header-left {
    display: none;
  }
  
  .desktop-nav {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: block;
  }
  
  .header-container {
    padding: 0 20px;
    justify-content: space-between;
  }
  
  /* Move profile to left on mobile */
  .header-center {
    position: static;
    left: auto;
    transform: none;
    order: 1;
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
  /* Keep navigation on right, hide theme toggle on mobile */
  .header-right {
    order: 2;
  }
  
  /* Hide desktop theme toggle on mobile */
  .header-right .theme-toggle {
    display: none;
  }
  
  /* Hide all social icons on mobile */
  .social-icon.mobile-hidden {
    display: none;
  }
  
  .social-icon.mobile-visible {
    display: none;
  }
  
  /* Hide mobile email icon */
  .mobile-email-icon {
    display: none;
  }
  
  .social-icon.mobile-only {
    display: none;
  }
  
  .profile-name {
    font-size: 24px;
  }
  
  .profile-image {
    width: 50px;
    height: 50px;
  }
}

@media (max-width: 480px) {
  .header {
    height: 100px;
  }
  
  .header-container {
    padding: 0 15px;
  }
  
  .profile-name {
    font-size: 22px;
  }
  
  .profile-image {
    width: 45px;
    height: 45px;
  }
  
  .theme-toggle {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .mobile-nav {
    padding: 20px 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,aAAa;EACb,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,gDAAgD;EAChD,aAAa;EACb,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yDAAyD;EACzD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6EAA6E;EAC7E,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;EAC7C,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kCAAkC;EAClC,0BAA0B;EAC1B,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA,mCAAmC;EACnC;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA,0DAA0D;EAC1D;IACE,QAAQ;EACV;;EAEA,wCAAwC;EACxC;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA,2BAA2B;EAC3B;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Modern Header Styles */\n.header {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 120px;\n  background: rgba(29, 26, 22, 0.95);\n  -webkit-backdrop-filter: blur(20px);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(177, 133, 90, 0.2);\n  z-index: 1000;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"light\"] .header {\n  background: rgba(247, 243, 238, 0.95);\n  border-bottom: 1px solid rgba(140, 90, 51, 0.2);\n}\n\n.header-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 40px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n}\n\n/* Left Section - Social Icons */\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(177, 133, 90, 0.1);\n  border: 1px solid rgba(177, 133, 90, 0.3);\n  text-decoration: none;\n  transition: all 0.3s ease;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n}\n\n.social-icon:hover {\n  background: var(--accent-coffee);\n  border-color: var(--accent-coffee);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(177, 133, 90, 0.4);\n}\n\n.social-icon svg {\n  width: 20px;\n  height: 20px;\n  transition: all 0.3s ease;\n}\n\n.social-icon:hover svg {\n  transform: scale(1.1);\n}\n\n/* LinkedIn - Original blue color */\n.social-icon[aria-label=\"LinkedIn\"] svg {\n  color: #0077b5;\n}\n\n/* Gmail - Original red color */\n.social-icon[aria-label=\"Gmail\"] svg {\n  color: #ea4335;\n}\n\n/* GitHub - Original black color */\n.social-icon[aria-label=\"GitHub\"] svg {\n  color: #333333;\n}\n\n/* Center Section - Profile */\n.header-center {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n}\n\n\n.profile-container {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.profile-image {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 3px solid var(--accent-coffee);\n  box-shadow: 0 4px 15px rgba(177, 133, 90, 0.3);\n  transition: all 0.3s ease;\n}\n\n.profile-image:hover {\n  transform: scale(1.05);\n  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.4);\n}\n\n.profile-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: all 0.3s ease;\n}\n\n.profile-name {\n  font-family: 'Playfair Display', 'Times New Roman', serif;\n  font-size: 36px;\n  font-weight: 400;\n  font-style: italic;\n  color: var(--text-primary);\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n}\n\n.profile-container:hover .profile-name {\n  color: var(--accent-coffee);\n  transform: translateX(2px);\n}\n\n/* Right Section - Navigation & Theme Toggle */\n.header-right {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n/* Navigation */\n.header-nav {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.nav-link {\n  color: var(--text-primary);\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 16px;\n  padding: 8px 0;\n  position: relative;\n  transition: all 0.3s ease;\n  letter-spacing: 0.3px;\n}\n\n.nav-link::after {\n  content: '';\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, var(--accent-coffee), var(--accent-beige));\n  transition: all 0.3s ease;\n}\n\n.nav-link:hover {\n  color: var(--accent-coffee);\n  transform: translateY(-1px);\n}\n\n.nav-link:hover::after {\n  width: 100%;\n}\n\n.nav-link.active {\n  color: var(--accent-coffee);\n  font-weight: 600;\n}\n\n.nav-link.active::after {\n  width: 100%;\n}\n\n/* Navigation Icons */\n.nav-icon {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 8px;\n  transition: all 0.3s ease;\n}\n\n.nav-link:hover .nav-icon {\n  transform: scale(1.1);\n}\n\n/* Theme Toggle */\n.theme-toggle {\n  background: var(--accent-coffee);\n  color: var(--accent-cream);\n  border: 2px solid var(--border-color);\n  border-radius: 50%;\n  width: 44px;\n  height: 44px;\n  font-size: 18px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(177, 133, 90, 0.3);\n}\n\n.theme-toggle:hover {\n  background: var(--accent-beige);\n  transform: scale(1.05) rotate(15deg);\n  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.4);\n}\n\n/* Mobile Menu Toggle */\n.mobile-menu-toggle {\n  display: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  border-radius: 8px;\n  transition: all 0.3s ease;\n}\n\n.mobile-menu-toggle:hover {\n  background: rgba(177, 133, 90, 0.1);\n}\n\n.hamburger {\n  display: flex;\n  flex-direction: column;\n  width: 28px;\n  height: 20px;\n  position: relative;\n}\n\n.hamburger span {\n  display: block;\n  height: 2px;\n  width: 100%;\n  background: var(--accent-coffee);\n  border-radius: 2px;\n  transition: all 0.3s ease;\n  transform-origin: center;\n}\n\n.hamburger span:nth-child(1) {\n  margin-bottom: 6px;\n}\n\n.hamburger span:nth-child(2) {\n  margin-bottom: 6px;\n}\n\n.hamburger.active span:nth-child(1) {\n  transform: rotate(45deg) translate(7px, 7px);\n}\n\n.hamburger.active span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(7px, -7px);\n}\n\n/* Mobile Navigation */\n.mobile-nav {\n  display: none;\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background: rgba(29, 26, 22, 0.98);\n  -webkit-backdrop-filter: blur(20px);\n  backdrop-filter: blur(20px);\n  border-top: 1px solid rgba(177, 133, 90, 0.3);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\n  flex-direction: column;\n  padding: 30px 40px;\n  gap: 20px;\n  z-index: 999;\n}\n\n[data-theme=\"light\"] .mobile-nav {\n  background: rgba(247, 243, 238, 0.98);\n}\n\n.mobile-nav.active {\n  display: flex;\n}\n\n.mobile-nav .nav-link {\n  padding: 16px 20px;\n  border-radius: 12px;\n  background: rgba(177, 133, 90, 0.1);\n  text-align: center;\n  font-weight: 600;\n  font-size: 18px;\n  border: 1px solid rgba(177, 133, 90, 0.2);\n  transition: all 0.3s ease;\n}\n\n.mobile-nav .nav-link:hover {\n  background: var(--accent-coffee);\n  color: var(--accent-cream);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);\n}\n\n.mobile-nav .nav-link::after {\n  display: none;\n}\n\n.mobile-nav .nav-link.active {\n  background: var(--accent-coffee);\n  color: var(--accent-cream);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);\n}\n\n/* Mobile Theme Toggle */\n.mobile-theme-toggle {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid rgba(177, 133, 90, 0.3);\n  display: flex;\n  justify-content: center;\n}\n\n.mobile-theme-btn {\n  width: 50px;\n  height: 50px;\n  font-size: 20px;\n  border-radius: 12px;\n  background: rgba(177, 133, 90, 0.1);\n  border: 2px solid rgba(177, 133, 90, 0.3);\n  transition: all 0.3s ease;\n}\n\n.mobile-theme-btn:hover {\n  background: var(--accent-coffee);\n  transform: scale(1.05);\n  box-shadow: 0 6px 20px rgba(177, 133, 90, 0.3);\n}\n\n/* Mobile Overlay */\n.mobile-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n  z-index: 998;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .header-container {\n    padding: 0 30px;\n  }\n  \n  .header-nav {\n    gap: 24px;\n  }\n}\n\n@media (max-width: 768px) {\n  .header-left {\n    display: none;\n  }\n  \n  .desktop-nav {\n    display: none;\n  }\n  \n  .mobile-menu-toggle {\n    display: block;\n  }\n  \n  .header-container {\n    padding: 0 20px;\n    justify-content: space-between;\n  }\n  \n  /* Move profile to left on mobile */\n  .header-center {\n    position: static;\n    left: auto;\n    transform: none;\n    order: 1;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n  }\n  \n  /* Keep navigation on right, hide theme toggle on mobile */\n  .header-right {\n    order: 2;\n  }\n  \n  /* Hide desktop theme toggle on mobile */\n  .header-right .theme-toggle {\n    display: none;\n  }\n  \n  /* Hide all social icons on mobile */\n  .social-icon.mobile-hidden {\n    display: none;\n  }\n  \n  .social-icon.mobile-visible {\n    display: none;\n  }\n  \n  /* Hide mobile email icon */\n  .mobile-email-icon {\n    display: none;\n  }\n  \n  .social-icon.mobile-only {\n    display: none;\n  }\n  \n  .profile-name {\n    font-size: 24px;\n  }\n  \n  .profile-image {\n    width: 50px;\n    height: 50px;\n  }\n}\n\n@media (max-width: 480px) {\n  .header {\n    height: 100px;\n  }\n  \n  .header-container {\n    padding: 0 15px;\n  }\n  \n  .profile-name {\n    font-size: 22px;\n  }\n  \n  .profile-image {\n    width: 45px;\n    height: 45px;\n  }\n  \n  .theme-toggle {\n    width: 40px;\n    height: 40px;\n    font-size: 16px;\n  }\n  \n  .mobile-nav {\n    padding: 20px 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
